import React, { memo, useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { productImageSliderSettings } from 'core/config/slides';
import { QuickViewButton } from './QuickViewButton';
import { productImagePropTypes } from 'core/propTypes/propTypes';
import { all_routes } from 'core/data/routes/all_routes';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';

export const ProductImage = memo(({
    images,
    publicUrl,
    badge,
    selectedOption,
    sliderRef,
    onQuickView,
    id,
    appliedPhotos
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            className="product-img product-option aspec-ratio-1-1"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Link to={all_routes.productDetails + "/" + id} >
                <Slider ref={sliderRef} {...productImageSliderSettings}>
                    <ImageWithBaseApi
                        src={isHovered && appliedPhotos?.length > 0 ? appliedPhotos[0].src : (selectedOption ? selectedOption.url : images[0])}
                        alt="Product"
                        className="product-card__image"
                    />
                </Slider>
                {badge && (
                    <div className="product-badge" style={{ minHeight: 'unset', right: '0px' }}>
                        <ul>
                            <li className="sale-badge badge-sale">{badge}</li>
                        </ul>
                    </div>
                )}
            </Link>
            <QuickViewButton onClick={onQuickView} />
        </div>
    );
});

ProductImage.propTypes = productImagePropTypes;